export const OTP_REQUEST_EVENT = "otprequest";

export class OtpRequestEvent extends Event {
  apiPath?: string;

  constructor(apiPath?: string) {
    super(OTP_REQUEST_EVENT);
    this.apiPath = apiPath;
  }
}
